/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import { filter } from 'underscore';

import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getTabbableNodes, addDataFocus } from '@bingads-webui-react/focus-lock';

import { getTopGridPanelDefaultStyles } from './panel-styles';

class TopGridPanelUnStyled extends React.PureComponent {
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
  }

  componentDidMount() {
    if (this.rootRef && this.rootRef.current) {
      // filter the not visible element out which may due to parent display property
      const tabbableNode = filter(getTabbableNodes(this.rootRef.current), item => $(item).is(':visible'));

      if (tabbableNode && tabbableNode.length > 0) {
        tabbableNode[0].focus({
          preventScroll: true,
        });
      }
      addDataFocus(this.rootRef.current);
    }
  }

  render() {
    let panelContent = (null);
    const {
      panelView, customClasses, classes,
    } = this.props;

    if (panelView) {
      if (React.isValidElement(panelView)) {
        panelContent = panelView;
      } else {
        panelContent = (
          <BackboneInstanceWrapper
            managed
            instance={panelView}
          />
        );
      }
    }

    return (
      <div id="bulkEditContainer" ref={this.rootRef} className={classNames(['top-grid-form', customClasses.topGridPanelCustomStyles, classes.topGridPanelDefaultStyles])}>
        {panelContent}
      </div>
    );
  }
}

TopGridPanelUnStyled.propTypes = {
  panelView: PropTypes.shape({
    render: PropTypes.func,
  }),
  classes: PropTypes.shape({
    topGridPanelDefaultStyles: PropTypes.string.isRequired,
  }).isRequired,
  customClasses: PropTypes.object, // eslint-disable-line
};

TopGridPanelUnStyled.defaultProps = {
  panelView: null,
  customClasses: {},
};

export const TopGridPanel = withDefaultStyles(
  TopGridPanelUnStyled,
  getTopGridPanelDefaultStyles
);
